import { OnInit, Component } from '@angular/core';
import { UserInfo } from 'src/app/common/interfaces/user.interface';
import { AuthService } from './../../../service/api';

@Component({
  templateUrl: 'user-info.component.html',
  styleUrls: ['user-info.component.scss']
})
export class UserInfoComponent implements OnInit {

  userInfo: UserInfo = null;

  constructor(protected authService: AuthService) {}

  ngOnInit(): void {
    this.getUserInfo();
  }

  getUserInfo() {
    this.authService.userInfo$.subscribe(res => this.userInfo = res);
  }

  handleLogout() {
    this.authService.logout();
  }
}
